import axios from 'axios';
import type {
  Notification,
  NotificationListResponse,
  UnreadCountResponse,
} from '../types/notification';

const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000';

/**
 * 알림 서비스
 */
class NotificationService {
  /**
   * 알림 목록 조회
   */
  async getNotifications(params?: {
    limit?: number;
    offset?: number;
    is_read?: boolean;
  }): Promise<NotificationListResponse> {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('No access token found');
    }

    const queryParams = new URLSearchParams();
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.offset) queryParams.append('offset', params.offset.toString());
    if (params?.is_read !== undefined) queryParams.append('is_read', params.is_read.toString());

    const response = await axios.get<{ success: boolean; data: NotificationListResponse }>(
      `${API_URL}/api/v1/notifications?${queryParams}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.data;
  }

  /**
   * 읽지 않은 알림 개수 조회
   */
  async getUnreadCount(): Promise<number> {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('No access token found');
    }

    const response = await axios.get<{ success: boolean; data: UnreadCountResponse }>(
      `${API_URL}/api/v1/notifications/unread-count`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.data.count;
  }

  /**
   * 알림을 읽음으로 표시
   */
  async markAsRead(notificationId: string): Promise<Notification> {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('No access token found');
    }

    const response = await axios.post<{ success: boolean; data: Notification }>(
      `${API_URL}/api/v1/notifications/${notificationId}/read`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.data;
  }

  /**
   * 모든 알림을 읽음으로 표시
   */
  async markAllAsRead(): Promise<void> {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('No access token found');
    }

    await axios.post(
      `${API_URL}/api/v1/notifications/read-all`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }

  /**
   * 알림 삭제
   */
  async deleteNotification(notificationId: string): Promise<void> {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('No access token found');
    }

    await axios.delete(`${API_URL}/api/v1/notifications/${notificationId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
}

export default new NotificationService();
